module.exports = __webpack_public_path__ + "img/register-success.8c310d40.png";